import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { createTivConversation } from '../../api/tiv';
import ConversationCard from './ConversationCard';
import { AuthContext } from '../../context/AuthContext';
import PremiumModal from "../../components/premium/PremiumModal";

/**
 * @param {{ prenom: string, conversations: import('../../types/tiv').TivConversation[] }} props
 */
export default function TivConversations({ prenom, conversations }) {
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);
  const { user, updateUser } = useContext(AuthContext);
  const [showPremiumModal, setShowPremiumModal]   = useState(false);

  const drafts    = conversations.filter(c => c.status === 'draft');
  const published = conversations.filter(c => c.status !== 'draft');

  async function handleNewLetter() {
    if ( !user.paid_tiv ) {
      setShowPremiumModal(true)
    } else {
      setCreating(true);
      try {
        const conv = await createTivConversation({});
        navigate(`/tiv/lettre-motivation/${conv.id}`);
      } finally {
        setCreating(false);
      }
    }
  }

  return (
    <div className="flex flex-col gap-6">
      {conversations.length === 0 && (
        <div className="text-center mb-2">
          <p className="text-base font-semibold text-white">
            Salut {prenom || 'toi'}, moi c'est Tiv.
          </p>
          <p className="text-sm text-zinc-400 mt-1 leading-relaxed">
            On écrit ta première lettre de motivation Parcoursup ?
          </p>
        </div>
      )}

      <button
        onClick={handleNewLetter}
        disabled={creating}
        className="w-full flex items-center justify-center gap-2 py-4 bg-blue-600 hover:bg-blue-500 disabled:opacity-60 transition-colors rounded-2xl text-white text-sm font-bold"
      >
        {creating ? (
          <span className="w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin" />
        ) : (
          <>
            {conversations.length === 0 ? "C'est parti" : 'Écrire une nouvelle lettre'}
            <ArrowRight size={16} />
          </>
        )}
      </button>

      {drafts.length > 0 && (
        <div>
          <p className="text-[11px] font-bold text-zinc-500 uppercase tracking-widest mb-2.5">
            En cours
          </p>
          <div className="flex flex-col gap-2">
            {drafts.map(conv => (
              <ConversationCard
                key={conv.id}
                conv={conv}
                onClick={() => navigate(`/tiv/lettre-motivation/${conv.id}`)}
              />
            ))}
          </div>
        </div>
      )}

      {published.length > 0 && (
        <div>
          <p className="text-[11px] font-bold text-zinc-500 uppercase tracking-widest mb-2.5">
            Terminées
          </p>
          <div className="flex flex-col gap-2">
            {published.map(conv => (
              <ConversationCard
                key={conv.id}
                conv={conv}
                onClick={() => navigate(`/tiv/lettre-motivation/${conv.id}/detail`)}
              />
            ))}
          </div>
        </div>
      )}


      <PremiumModal
        isOpen={showPremiumModal}
        onClose={() => setShowPremiumModal(false)}
        askedForPremium={user?.asked_for_premium}
        onUpdateUser={updateUser}
        context="TIV est réservé aux membres Premium +"
        reason="faire ses lettres de motivation avec Tiv"
      />
      
    </div>
  );
}
